export default __webpack_public_path__ + "static/media/P20_Micropipette.e0e3175d.svg";